import React from "react";
import Counter from "./Counter/Counter";
import classes from "./Odometer.module.css";

//THIS Component creates an Odometer Animation
/*props={
  value,      for the number displayed in the Odometer
  className,  to add styles to the container
  CounterClassName, to add styles specific for the counter (numbers)
  commaClassName, to add styles to the commas between the numbers
}
  */
const Odometer = (props) => {
  var intArr = Array.from(String(props.value));

  return (
    <div className={classes.container + " " + props.className}>
      {/* Each digit needs a counter to count up to that number */}
      {/* The if statements determine where to add commas (There is maybe a better way to do it ;p) */}
      {intArr.map((char, index) => {
        if (intArr.length % 3 === 1 && (index === 1 || (index + 2) % 3 === 0)) {
          return (
            <div className={classes.commaContainer} key={index}>
              <span
                className={props.CounterClassName + " " + props.commaClassName}
                style={{
                  height: `${props.height}px`,
                  fontSize: `${props.height * 0.9}px`,
                }}
              >
                ,
              </span>
              <Counter
              duration={props.duration}
                height={props.height}
                value={parseInt(char)}
                className={props.CounterClassName}
              />
            </div>
          );
        } else if (
          intArr.length % 3 === 2 &&
          (index === 2 || (index + 1) % 3 === 0)
        ) {
          return (
            <div className={classes.commaContainer} key={index}>
              <span
                className={props.CounterClassName + " " + props.commaClassName}
                style={{
                  height: `${props.height}px`,
                  fontSize: `${props.height * 0.9}px`,
                }}
              >
                ,
              </span>
              <Counter
                key={index}
                duration={props.duration}
                height={props.height}
                value={parseInt(char)}
                className={props.CounterClassName}
              />
            </div>
          );
        }
        if (intArr.length % 3 === 0 && index % 3 === 0 && index !== 0) {
          return (
            <div className={classes.commaContainer} key={index}>
              <span
                className={props.CounterClassName + " " + props.commaClassName}
                style={{
                  height: `${props.height}px`,
                  fontSize: `${props.height * 0.9}px`,
                }}
              >
                ,
              </span>
              <Counter
                height={props.height}
                duration={props.duration}
                value={parseInt(char)}
                key={index}
                className={props.CounterClassName}
              />
            </div>
          );
        }

        return (
          <Counter
            height={props.height}
            duration={props.duration}
            value={parseInt(char)}
            key={index}
            className={props.CounterClassName}
          />
        );
      })}
    </div>
  );
};
export default Odometer;
